import { render } from "./AppWrapper.vue?vue&type=template&id=1bedf48c&scoped=true"
import script from "./AppWrapper.vue?vue&type=script&lang=js"
export * from "./AppWrapper.vue?vue&type=script&lang=js"

import "./AppWrapper.vue?vue&type=style&index=0&id=1bedf48c&scoped=true&lang=scss"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bedf48c"]])

export default __exports__